export const getStoreDisplayLabel = (store: any = {}): string => {
    const entityType = store.ENTITY_TYPE?.toUpperCase();
    if (entityType === 'STATISTIC' || entityType === 'COMPANY' || entityType === 'ROOT') {
        return store.NAME || '';
    }
    return store.LOCAL_CITY_NAME || store.NAME || '';
};

export const getStoreSearchLabel = (store: any = {}): string =>
    `${store.IDENTIFIER || ''} – ${getStoreDisplayLabel(store)}`;

const normalizeSearchValue = (value: string): string =>
    value
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim();

export const storeMatchesSearch = (store: any = {}, inputValue: string): boolean => {
    if (!inputValue) return true;

    const search = normalizeSearchValue(inputValue);
    const label = normalizeSearchValue(getStoreSearchLabel(store));

    return (
        label.includes(search) ||
        store.ENTITY_ID?.toString().includes(search)
    );
};
